import React from "react";
import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { AuthorityDisplayNameMap } from "@/models";
import { Authority } from "@/generated/graphql";

type Props = {
  authority: Authority;
};

export const AuthorityBlockUneditable = ({ authority }: Props) => {
  const isSpMode = useIsSpMode();
  return (
    // 変更不可のためツールチップは不要
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          権限
        </Font>
      </div>
      <div css={inputWrapper}>
        <Font>{AuthorityDisplayNameMap.get(authority)}</Font>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "200px",
  marginRight: "15px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  paddingTop: "8px",
});
